import React from 'react';
import { Modal } from './Modal';
import { Button, SecondaryButton } from './Button';
import styled from 'styled-components';
import VipIcon from '../Icons/VipIcons';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0;
`;

const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primaryGradientLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const Message = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 8px 0;
`;

const SubMessage = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 24px;
  
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const LoginPromptModal = ({ 
  show, 
  onHide, 
  onLogin,
  message = 'Please log in to continue',
  title = 'Login Required'
}) => {
  return (
    <Modal
      isOpen={show}
      onClose={onHide}
      title={title}
      maxWidth="400px"
    >
      <ContentWrapper>
        <IconWrapper>
          <VipIcon name="Profile" size={32} />
        </IconWrapper>
        <Message>{message}</Message>
        <SubMessage>
          Join our community to interact with posts, follow creators, and more.
        </SubMessage>
        <ButtonGroup>
          <SecondaryButton
            onClick={onHide}
            $rounded
            style={{ flex: 1 }}
          >
            Maybe Later
          </SecondaryButton>
          <Button
            onClick={onLogin}
            $rounded
            style={{ flex: 1 }}
          >
            Log In
          </Button>
        </ButtonGroup>
      </ContentWrapper>
    </Modal>
  );
};

export default LoginPromptModal;
